<app-description id="step2" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [description]="initial.description"
[natureMarche]="initial.natureMarche"></app-description>
